import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class RiskValidationService {
  constructor(private http: HttpClientService) {}

  // # GET /api/applications/:application_id/risk_approval_audit
  public getAuditByApp(app_id: string | number): Observable<any> {
    return this.http
      .get(`/api/applications/${app_id}/risk_approval_audit`)
      .pipe(tap((_) => console.log("RiskValidationService.getAuditByApp: Ok")));
  }
}
